module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image4-8bbaa28f86292b1eb7e9e21e32f5f168.png";